module.exports = __webpack_public_path__ + "placa_ar_10x_s_entr_s_juros.png?ff8f24c9a2fedd3cff8af55b34c0f4d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_ar_10x_s_entr_s_juros.png
// module id = 119
// module chunks = 0